import skNavigation from './sk/navigation';
import skEaiSubjects from './sk/eai/subjects';
import skEaiUsers from './sk/eai/users';
import skEaiDeliveryPoints from './sk/eai/deliveryPoints';
import skEaiBalanceGroups from './sk/eai/balanceGroups';
import skEaiDevices from './sk/eai/devices';
import skEaiDeliveryContracts from 'assets/translations/sk/eai/deliveryContracts';
import skEaiCodebooks from './sk/eai/codebooks';
import skEaiMessages from './sk/eai/messages';
import skCalendar from 'assets/translations/sk/dispatcher/calendar';
import skDispatcherOnlineDispatching from 'assets/translations/sk/dispatcher/onlineDispatching';
import skDispatcherProductionPlanning from './sk/dispatcher/productionPlanning';
import skDispatcherCodebooks from 'assets/translations/sk/dispatcher/codebooks';
import { i18nTranslation } from 'models/i18n';
import {
  DeviceInstallationStatus,
  EMSMemberAccountStatus,
  MarketPeriodsType,
  UserAccountStatus
} from 'utils/constants';
import { DispatcherValidationError } from 'models/dispatcher';
import skDispatcherWeatherWidget from 'assets/translations/sk/dispatcher/weatherWidget';
import { caReasonsCodesSK } from 'assets/translations/sk/caReasonsCodes/caReasonsCodes';
import reporting from './sk/reporting/reporting';
import skHomePage from 'assets/translations/sk/homePage';
import skSystemActivityEvents from 'assets/translations/sk/system/activityEvents';
import skSystemCodebooks from 'assets/translations/sk/system/codebooks';
import skSystemActivityLogs from 'assets/translations/sk/system/activityLogs';
import skHxDashboard from 'assets/translations/sk/dispatcher/hxDashboard';
import skRkDashboard from 'assets/translations/sk/dispatcher/rkDashboard';
import { GridDensity } from 'components/dataGrid/dataGridModels';
import { AlarmsColumn } from 'views/modules/System/Alarms/alarmsModels';
import { ProductionModelProfileType } from 'components/productionModelConfiguration/productionModelUtils';

// ==============================|| I18N SK ||============================== //

const translate: i18nTranslation = {
  header: {
    localization: {
      sk: 'Slovensky',
      en: 'English'
    },
    profile: {
      darkMode: 'Tmavý režim',
      logout: 'Odhlásiť',
      changeSubject: 'Zmeniť subjekt',
      version: 'Verzia aplikácie'
    }
  },
  navigation: skNavigation,
  module: {
    crossModule: {
      productionModel: {
        listOfModels: {
          actions: {
            addModel: 'Pridať model',
            editModel: 'Upraviť model',
            removeModel: 'Odstrániť model',
            removeAllModels: 'Odstrániť všetky modely',
            showModel: 'Zobraziť model'
          },
          columns: {
            startDate: 'Dátum od',
            endDate: 'Dátum do',
            profileType: 'Spôsob zadania'
          },
          errors: {
            overlappingDateRange: 'Rozsahy dátumov sa prekrývajú',
            validationErrorInModel: 'Model obsahuje chyby',
            rangeError: 'Dátum do musí byť väčší ako dátum od'
          },
          isDefault: 'Predvolený'
        },
        modelDetail: {
          actions: {
            startDate: 'Dátum od',
            endDate: 'Dátum do',
            profileType: 'Spôsob zadania'
          },
          columns: {
            period: 'Perióda',
            commonProductionMwh: 'Energia [MWh]',
            workdaysProductionMwh: 'Energia prac. dni [MWh]',
            weekendProductionMwh: 'Energia víkendy [MWh]'
          },
          isDefault: 'Označiť ako predvolený'
        },
        profileType: {
          [ProductionModelProfileType.COMMON]: 'Jednotný profil',
          [ProductionModelProfileType.WORKDAYS_WEEKENDS]: 'Prac. dni / víkendy'
        }
      }
    },
    dispatcher: {
      productionPlanning: skDispatcherProductionPlanning,
      operationCalendar: skCalendar,
      onlineDispatching: skDispatcherOnlineDispatching,
      hxDashboard: skHxDashboard,
      rkDashboard: skRkDashboard,
      periodText: ' obchodná perióda',
      currentTime: 'Aktuálny čas: ',
      dataGrid: {
        columns: {
          title: 'Stĺpce'
        },
        density: {
          title: 'Hustota',
          [GridDensity.COMPACT]: 'Kompaktná',
          [GridDensity.STANDARD]: 'Štandardná',
          [GridDensity.COMFORTABLE]: 'Komfortná'
        }
      },
      messages: {
        eventCreated: 'Udalosť úspešne vytvorená',
        errorCreatingEvent: 'Chyba pri vytváraní udalosti',
        updateOperationCalendarEvent: 'Udalosť úspešne upravená',
        invalidateOperationEvent: 'Udalosť úspešne zneplatnená',
        deleteOperationCalendarEvent: 'Udalosť úspešne zmazaná',
        productionPlanCreated: 'Plán produkcie bol úspešne vytvorený',
        productionPlanUpdated:
          'Nová revízia plánu produkcie bola úspešne vytvorená',
        productionPlanPropagated:
          'Revízia plánu produkcie bola úspešne odpropagovaná',
        productionPlanConfirmed:
          'Revízia plánu produkcie bola úspešne potvrdená',
        productionPlanCopied:
          'Revízia plánu produkcie bola úspešne skopírovaná na zvolené dni',
        dailyDiagramCreated: 'Denný diagram bol úspešne vytvorený',
        dailyDiagramUpdated: 'Denný diagram bol úspešne aktualizovaný',
        dailyDiagramAccepted: 'Denný diagram bol úspešne akceptovaný',
        dailyDiagramValidationErrors:
          'Denný diagram nie je možné akceptovať. Pred akceptáciou denného diagramu je potrebné odstrániť nasledujúce chyby:',
        dailyDiagramValidationWarningsPrefix:
          'Denný diagram obsahuje upozornenia:',
        dailyDiagramValidationWarningsPostfix:
          'Naozaj si prajete akceptovať denný diagram napriek týmto upozorneniam?',
        [DispatcherValidationError.MUST_BE_INTEGER]:
          'Hodnota musí byť celé číslo',
        [DispatcherValidationError.MAX_2_DECIMALS]:
          'Hodnota musí byť číslo s maximálne 2 desatinnými miestami',
        [DispatcherValidationError.MAX_3_DECIMALS]:
          'Hodnota musí byť číslo s maximálne 3 desatinnými miestami',
        [DispatcherValidationError.MAX_5_DECIMALS]:
          'Hodnota musí byť číslo s maximálne 5 desatinnými miestami',
        [DispatcherValidationError.MAX_6_DECIMALS]:
          'Hodnota musí byť číslo s maximálne 6 desatinnými miestami',
        [DispatcherValidationError.MIN_VALUE]: 'Hodnota nesmie byť menšia než ',
        [DispatcherValidationError.MAX_VALUE]: 'Hodnota nesmie byť väčšia než ',
        [DispatcherValidationError.MUST_BE_ONE_OF]:
          'Hodnota musí byť jedna z hodnôt: ',
        [DispatcherValidationError.NOT_A_NUMBER]: 'Hodnota musí byť číslo',
        [DispatcherValidationError.POSITIVE_NUMBER]:
          'Hodnota musí byť kladné číslo',
        [DispatcherValidationError.EXPONENTIAL_NUMBER]:
          'Číslo nesmie byť v exponenciálnom formáte'
      },
      codebooks: skDispatcherCodebooks,
      weatherWidget: skDispatcherWeatherWidget
    },
    eai: {
      users: skEaiUsers,
      subjects: skEaiSubjects,
      balanceGroups: skEaiBalanceGroups,
      deliveryPoints: skEaiDeliveryPoints,
      devices: skEaiDevices,
      deliveryContracts: skEaiDeliveryContracts,
      codebooks: skEaiCodebooks,
      messages: skEaiMessages
    },
    reporting,
    homePage: skHomePage,
    system: {
      activityEvents: skSystemActivityEvents,
      codebooks: skSystemCodebooks,
      activityLogs: skSystemActivityLogs,
      alarms: {
        resolveAlarmDialog: {
          title: 'Riešenie alarmu',
          description:
            'Naozaj chcete vyriešiť tento alarm? K vyriešeniu je potrebné zadať poznámku.',
          inputLabel: 'Poznámka',
          resolveButton: 'Áno vyriešiť'
        },
        cancelAlarmDialog: {
          title: 'Zrušenie alarmu',
          description:
            'Naozaj chcete zrušíť tento alarm? K zrušeniu je potrebné zadať poznámku.',
          inputLabel: 'Poznámka',
          cancelButton: 'Áno zrušíť'
        },
        filter: {
          triggeredFrom: 'Dátum od',
          triggeredTo: 'Dátum do',
          buttonApply: 'Aplikovať',
          dateRangeError: 'Zadajte dátumový rozsah maximálne týždeň'
        },
        table: {
          columns: {
            [AlarmsColumn.TRIGGERED_AT]: 'Čas alarmu',
            [AlarmsColumn.CODE]: 'Kód',
            [AlarmsColumn.SEVERITY]: 'Závažnosť',
            [AlarmsColumn.STATUS]: 'Stav',
            [AlarmsColumn.PARAMETERS]: 'Alarm',
            [AlarmsColumn.TAGS]: 'Tagy',
            [AlarmsColumn.MARKET_PARTICIPANT]: 'Účastník trhu',
            [AlarmsColumn.BALANCING_GROUP]: 'Bilančná skupina',
            [AlarmsColumn.DELIVERY_POINT]: 'Odberné miesto',
            [AlarmsColumn.DEVICE]: 'Zariadenie',
            [AlarmsColumn.ACTIONS]: 'Akcie'
          }
        }
      }
    }
  },
  pages: {
    crashFallback: {
      headline: 'Ups, niečo sa pokazilo',
      message: 'Zaznamenali sme interný problem s aplikáciou',
      messageCopied: 'Chybový záznam skopírovaný do clipboardu: ',
      button: {
        copy: 'Kopírovať chybový záznam',
        restore: 'Obnoviť'
      }
    }
  },
  dialogs: {
    businessTimeDialog: {
      title: 'Skontrolujte nastavenie vášho systémového času',
      message:
        'Váš systémový čas {{systemTime}} je posunutý oproti skutočnému obchodnému času {{businessTime}}'
    },
    selectEmsMemberAccount: {
      title: 'Zvoľte subjekt, s ktorým chcete pracovať',
      noSubjectDescriptionBegin:
        'Používateľ nemá priradený žiadny účet subjektu. Pre viac informácií kontaktujte administrátora alebo využite možnosť',
      noSubjectLogoutButton: 'prihlásiť sa s iným používateľským účtom'
    },
    addCredentials: {
      title: 'Pridať prístupové údaje',
      addCredentialsButton: 'Pridať údaje'
    },
    removeCredentials: {
      title: 'Odobrať prístupové údaje',
      description:
        'Naozaj si prajete odobrať prústupové údaje? Po odobratí užívateľ nebude môcť pristupovať k externej službe.',
      submitButtonTitle: 'Áno odobrať'
    },
    emsMemberAccountStateDialog: {
      description: {
        [EMSMemberAccountStatus.ACTIVE]:
          'Naozaj si prajete zneplatniť účet subjektu? Po zneplatntní bude účet dočasne uzamknutý a používateľ nebude môcť pristupovať k svojim údajom alebo vykonávať akékoľvek činnosti na platforme.',
        [EMSMemberAccountStatus.INACTIVE]:
          'Naozaj si prajete obnoviť účet subjektu? Po obnovení bude používateľ môcť používať svoj účet bez obmedzení.'
      },
      submitButtonTitle: {
        [EMSMemberAccountStatus.ACTIVE]: 'Áno zneplatniť',
        [EMSMemberAccountStatus.INACTIVE]: 'Áno obnoviť'
      }
    },
    userAccountStateDialog: {
      description: {
        [UserAccountStatus.ENABLED]:
          'Naozaj si prajete zneplatniť účet používateľa?  Po zneplatnení bude účet dočasne uzamknutý a používateľ nebude môcť pristupovať k svojim údajom alebo vykonávať akékoľvek činnosti na platforme.',
        [UserAccountStatus.DISABLED]:
          'Naozaj si prajete obnoviť účet používateľa? Po obnovení bude používateľ môcť používať svoj účet bez obmedzení.'
      },
      submitButtonTitle: {
        [UserAccountStatus.ENABLED]: 'Áno, zneplatniť',
        [UserAccountStatus.DISABLED]: 'Áno, obnoviť'
      }
    },
    unassignUserDialog: {
      title: 'Odstránenie účtu subjektu používateľa',
      description:
        'Naozaj si prajete odstrániť účet subjektu pri používateľovi? Po odstránení používateľ nebude môcť používať účet subjektu.',
      submitButtonTitle: 'Áno, odstrániť'
    },
    resetPasswordDialog: {
      description:
        'Naozaj si prajete resetovať heslo ? Používateľovi bude odoslaná výzva na zmenu hesla na emailovú adresu ',
      submitButtonTitle: 'Potvrdiť'
    },
    deleteSubjectDialog: {
      description:
        'Naozaj chcete natrvalo odstrániť subjekt zo systému? Akcia sa nedá vrátiť späť',
      submitButtonTitle: 'Áno, odstrániť'
    },
    deleteUserRoleDialog: {
      title: 'Odstránenie používateľskej role',
      description: 'Naozaj si prajete odstrániť používateľskú rolu?',
      submitButtonTitle: 'Áno, odstrániť'
    },
    setDeviceStatusDialog: {
      description: {
        [DeviceInstallationStatus.INSTALLED]:
          'Naozaj si prajete nastaviť stav zariadenia na Nenainštalované?',
        [DeviceInstallationStatus.NOT_INSTALLED]:
          'Naozaj si prajete nastaviť stav zariadenia na NainštalovaNé?'
      },
      submitButtonTitle: {
        [DeviceInstallationStatus.INSTALLED]: 'Áno, nastaviť',
        [DeviceInstallationStatus.NOT_INSTALLED]: 'Áno, nastaviť'
      }
    },
    createGDSDialog: {
      title: 'Vytvoriť GDS',
      description: 'Vytvoriť GDS pre OOM',
      submitButtonTitle: 'Odoslať',
      backButtonTitle: 'Späť'
    },
    changeDPAssignmentDialog: {
      title: 'Zmeniť priradenie',
      description: 'Zmeniť priradenie OOM',
      submitButtonTitle: 'Odoslať',
      backButtonTitle: 'Späť'
    },
    deleteDevice: {
      title: 'Odstrániť zariadenie',
      description: 'Naozaj si prajete odstrániť zariadenie?',
      submitButtonTitle: 'Áno, odstrániť'
    },
    deleteDeviceGroup: {
      title: 'Odstrániť skupinu zariadenia',
      description: 'Naozaj si prajete odstrániť skupinu zariadenia?',
      submitButtonTitle: 'Áno, odstrániť'
    },
    unassignDeliveryPoint: {
      title: 'Odstrániť priradenie odberného miesto',
      description: 'Naozaj si prajete odstrániť priradenie odberného miesta?',
      submitButtonTitle: 'Áno, odstrániť'
    },
    deleteUserDialog: {
      title: 'Zmazať používateľa',
      description:
        'Naozaj chcete natrvalo zmazať používateľa zo systému? Akcia sa nedá vrátiť späť.',
      submitButtonTitle: 'Áno, zmazať'
    },
    invalidateGDS: {
      title: 'Zneplatniť GDS',
      description:
        'Naozaj chcete zneplatniť vybranú komunikačnú bránu? Akcia sa nedá vrátit späť.',
      submitButtonTitle: 'Zneplatniť'
    }
  },
  common: {
    noItems: 'Žiadne položky',
    unitsOfMeasure: {
      kWh: 'kWh',
      kW: 'kW',
      MWh: 'MWh',
      kVAr: 'kVAr',
      PERCENT: '%',
      EUR: '€',
      A: 'A',
      V: 'V',
      METERS_ABOVE_SEA_LEVEL: 'm. n. m.',
      CUBIC_METRE_PER_SECOND: 'm³/s',
      Hz: 'Hz',
      EUR_PER_MEGAWATT_HOUR: '€/MWh',
      EUR_PER_KILOWATT_HOUR: '€/kWh',
      DEGREE_CELSIA: '°C',
      MILLIMETRE: 'mm',
      METRE_PER_SECOND: 'm/s',
      Pa: 'Pa',
      kW_PER_SQUARE_METRE: 'kW/m²',
      W_PER_SQUARE_METRE: 'W/m²'
    },
    marketPeriod: {
      [MarketPeriodsType.MARKET_PERIODS]: 'Obchodné periódy',
      [MarketPeriodsType.MARKET_HOURS]: 'Hodiny'
    },
    wizard: {
      review: 'Zhrnutie'
    },
    table: {
      filter: 'Filter',
      validFor: 'Platnosť',
      actions: 'Akcie',
      current: 'Aktuálna',
      inputSearch: 'Hľadať',
      rowsPerPage: 'Počet záznamov na stránku',
      of: 'z',
      moreThan: 'Viac ako',
      clearFilter: 'Zrušiť filtre',
      selectAll: 'Vybrať všetko',
      detail: 'Detail',
      delete: 'Vymazať',
      edit: 'Upraviť',
      resultsNotFound: 'Neboli nájdené žiadne záznamy',
      unassign: 'Odregistrovať GDS',
      unknownType: 'Neznámy typ',
      loading: 'Načítavanie ...'
    },
    button: {
      back: 'Späť',
      next: 'Ďalej',
      cancel: 'Zrušiť',
      saveChanges: 'Uložiť zmeny',
      add: 'Pridať',
      invalidate: 'Zneplatniť',
      ok: 'Potvrdiť',
      propagate: 'Propagovať',
      apply: 'Aplikovať',
      forceAccept: 'Akceptovať napriek varovaniam',
      edit: 'Zmeniť',
      export: 'Exportovať',
      clearSelection: 'Zrušiť výber',
      understand: 'Rozumiem',
      login: 'Prihlásiť sa'
    },
    status: {
      ACTIVE: 'Aktívny',
      INACTIVE: 'Neaktívny',
      BLOCKED: 'Zablokovaný'
    },
    messages: {
      caReasons: caReasonsCodesSK,
      ifNotMatch:
        'Informácie sa od posledného načítania stránky zmenili a už nie sú aktuálne.',
      ifNotMatchThen: 'Prajete si',
      forceSave: 'uložiť svoje zmeny',
      or: 'alebo',
      discardChanges: 'aktualizovať informácie',
      somethingIsWrong: 'Niečo sa nepodarilo',
      pageNotFound:
        'Stránka ktorú hľadáte bola presunutá, odstránená alebo možno nikdy neexistovala :(',
      noMenuPermissionsLabel: 'Nemáte pridelené práva',
      noMenuPermissionsText:
        'Pre aktuálny subjekt nemáte priradené žiadne oprávnenie. Pre pridelenie oprávnení kontaktuje administrátora.',
      noAccessPermissionsForPageLabel: 'Nepovolený prístup',
      noAccessPermissionsForPageText:
        'Nemáte oprávnenia pre zobrazenie tejto stránky. Pre pridelenie oprávnení kontaktuje administrátora.',
      noPagePermissionsForPageLabel: 'Nie ste oprávnení na danú akciu',
      noPagePermissionsForPageText:
        'Nie ste oprávnení na vykonanie danej akcie. V prípade potreby kontaktujte administrátora.',
      sessionTimeoutDialogLabel: 'Boli ste odhlásený zo systému',
      sessionTimeoutDialogText:
        'Vaša relácia vypršala. Pre pokračovanie sa znovu prihláste.'
    },
    chart: {
      noData: 'Neboli nájdené žiadne dáta',
      period: 'perióda'
    },
    httpErrorStatusMessages: {
      error400BadRequest:
        'Nastala neočakávaná chyba v požiadavke (kontaktujte systémového administrátora)',
      error401Unauthorized:
        'Nemáte oprávnenie na danú operáciu (kontaktujte systémového administratóra)',
      error403Forbidden:
        'Akciu aktuálne nie je možné vykonať (zopakujte akciu neskôr prípadne kontaktuje systémového administrátora)',
      error404NotFound: 'Entita v systéme neexistuje alebo bola zmazaná',
      error500InternalError:
        'Nastala neočakávaná chyba (kontaktujte systémového administrátora)'
    },
    qualityFlags: {
      qualityFlag: 'Príznak kvality',
      qualityFlagCodes: {
        OK: 'OK',
        A: 'Hodnota bola vypočítaná aproximovaným výpočtom',
        SB: 'Nahradená hodnota',
        T: 'Testovacia hodnota',
        M: 'Manuálne zadaná hodnota',
        OV: 'Pretečená hodnota',
        NT: 'Netopická hodnota',
        OB: 'Signál je blokovaný operátorom',
        IV: 'Neplatná hodnota'
      }
    }
  }
};

export default translate;
